import { Observable } from 'rxjs';
import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NavTabItem } from '@shared/models/nav-tab-item';
import { RouterService } from '@shared/services/router.service';

@Component({
  selector: 'app-nav-tab-header',
  templateUrl: './nav-tab-header.component.html',
  styleUrls: ['./nav-tab-header.component.scss'],
  standalone: false,
})
export class NavTabHeaderComponent implements OnInit, AfterViewInit {
  @Input() items: NavTabItem[];
  @Input() scrollableTabs: boolean = false;
  currentUrl$: Observable<string>;
  currentRoute$: Observable<any>;
  @ViewChild('tabList', { static: false }) tabList: ElementRef;
  showScrollLeft: boolean = false;
  showScrollRight: boolean = false;
  scrollAmount = 400;

  constructor(public routerService: RouterService) {}

  ngOnInit(): void {
    this.currentUrl$ = this.routerService.getCurrentUrl();
    this.currentRoute$ = this.routerService.getCurrentRoute();
    this.showScrollRight = this.scrollableTabs;
  }

  ngAfterViewInit() {
    if (this.scrollableTabs) {
      this.scrollIntoView();
      this.updateScrollButtonState();
    }
  }

  scrollTabs(direction: string) {
    if (direction === 'left') this.tabList.nativeElement.scrollLeft -= this.scrollAmount;
    if (direction === 'right') this.tabList.nativeElement.scrollLeft += this.scrollAmount;
    this.updateScrollButtonState();
  }

  updateScrollButtonState() {
    this.showScrollLeft = this.tabList.nativeElement.scrollLeft > 0;
    this.showScrollRight =
      this.tabList.nativeElement.scrollWidth -
        this.tabList.nativeElement.clientWidth -
        this.tabList.nativeElement.scrollLeft >
      0;
  }
  scrollIntoView() {
    const activeTabElement = document.querySelector('.active-tab');
    if (activeTabElement) activeTabElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }
}
